const initialState = [];
//
export default function cmSdepth0003(state = initialState, action) {
  switch (action.type) {
    case 'SET_CMSDEPTH0003':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CMSDEPTH0003_ERROR':
      return state;
    default:
      return state;
  }
}
